<div *ngIf="hasData; else firstTime">
  <p class="title">{{ proposals.titleMessage | translate }}</p>
  <app-proposal-card
    [proposal]="proposals.winter"
    [canEdit]="canEdit"
    [isMomoUser]="isMomoUser"
    (editClicked)="onActionClicked($event)"
    (addProposalsClicked)="onAddProposalsClicked($event)"></app-proposal-card>
  <app-proposal-card
    [proposal]="proposals.summer"
    [canEdit]="canEdit"
    [isMomoUser]="isMomoUser"
    (editClicked)="onActionClicked($event)"
    (addProposalsClicked)="onAddProposalsClicked($event)"></app-proposal-card>
  <app-observations-card
    [observations]="proposals.observations"
    [canEdit]="canEdit"
    (actionClicked)="onObservationsChanged($event)"
    *ngIf="canEdit || proposals.observations?.content"></app-observations-card>
</div>

<ng-template #firstTime>
  <p class="title">{{ 'MANAGE_VACATIONS.SELECT_VACATIONS_TO_REQUEST' | translate }}</p>
  <app-title-description-image-card
    [item]="season"
    *ngFor="let season of seasons; trackBy: trackByItems"
    (click)="onCardClicked(season)"></app-title-description-image-card>
</ng-template>
